import { render, staticRenderFns } from "./LoginBtn.vue?vue&type=template&id=53af47ee&scoped=true"
import script from "./LoginBtn.vue?vue&type=script&lang=js"
export * from "./LoginBtn.vue?vue&type=script&lang=js"
import style0 from "./LoginBtn.vue?vue&type=style&index=0&id=53af47ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53af47ee",
  null
  
)

export default component.exports